import React from "react";
import { CalendarOutlined, ClockCircleOutlined } from "@ant-design/icons";
import "./ResourceCard.scss";

const ResourceCard = ({
    title,
    subTitle,
    description,
    scheduledDate,
    scheduledTime,
    actions,
    onClick,
    className = "",
    icon,
    // Optional highlight pill, e.g. { label: "Admission", tone: "blue", icon: <FileTextOutlined /> }.
    // The tone also colours the card's left accent stripe so the type is recognisable at a glance.
    badge
}) => {
    const badgeTone = badge?.label ? (badge.tone || "default") : null;

    return (
        <div
            className={`resource-card ${badgeTone ? `resource-card--tone-${badgeTone}` : ""} ${className}`}
            onClick={onClick}
        >
            <div className="resource-card-body">
                {badge?.label && (
                    <div className="resource-card-badge-row">
                        <span className="resource-card-badge" title={badge.label}>
                            {badge.icon}
                            {badge.label}
                        </span>
                    </div>
                )}
                <div className="resource-card-header">
                    {icon && <div className="resource-card-icon">{icon}</div>}
                    <h3 className="resource-card-title" title={title}>{title}</h3>
                </div>
                {subTitle && <p className="resource-card-subtitle">{subTitle}</p>}
                {description && <p className="resource-card-description">{description}</p>}
                {(scheduledDate || scheduledTime) && (
                    <div className="resource-card-schedule">
                        {scheduledDate && (
                            <span className="resource-card-schedule-item">
                                <CalendarOutlined />
                                {scheduledDate}
                            </span>
                        )}
                        {scheduledTime && (
                            <span className="resource-card-schedule-item">
                                <ClockCircleOutlined />
                                {scheduledTime}
                            </span>
                        )}
                    </div>
                )}
            </div>

            {actions && (
                <div className="resource-card-footer" onClick={(e) => e.stopPropagation()}>
                    {actions}
                </div>
            )}
        </div>
    );
};

export default ResourceCard;
